import { isAxiosError } from 'axios';

const CONTENT_POLICY_VIOLATION_CODE = 1068;

interface ApiErrorResponse {
  internalErrorCode?: number;
  message?: string;
}

export const getContentModerationError = (e: unknown): string | null => {
  if (!isAxiosError<ApiErrorResponse>(e)) {
    return null;
  }
  const data = e.response?.data;
  if (data?.internalErrorCode === CONTENT_POLICY_VIOLATION_CODE) {
    return data.message ?? null;
  }
  return null;
};
